import React, {useState} from "react";
import {TextField} from "@mui/material";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {VALIDATE_GRAPHQL_QUERY} from "../graphql/mutations/gqlValidateGraphQlQuery";
import {LoadingButton} from "@mui/lab";
import {toast} from "react-toastify";

interface IGraphQlEditorProps {
	query: string;
	setQuery: (query: string) => void;
	anvaSyncStage?: string;
	anvaSyncAccount?: string;
}

export const GraphQlEditor: React.FC<IGraphQlEditorProps> = (props) => {
	const [response, setResponse] = useState<{ result: any; success: boolean; errors: {message: string; code: string}[] }>();
	const [loading, setLoading] = useState(false);
	const verifyQuery = () => {
		setLoading(true);
		graphQLServices.querytoolClient
			.mutate({
				mutation: VALIDATE_GRAPHQL_QUERY,
				variables: {
					graphQl: props.query,
					take: 10,
					...(props.anvaSyncStage ? { anvaSyncStage: props.anvaSyncStage } : {}),
					...(props.anvaSyncAccount ? { anvaSyncAccount: props.anvaSyncAccount } : {}),
				},
			})
			.then((result) => {
				setResponse(result.data.validateGraphQl as any);
			})
			.catch(it => toast.error("Error!"))
			.finally(() => setLoading(false));
	};
	
	return (
		<>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between"
				}}
			>
				<div
					style={{
						width: "55%"
					}}
				>
					<TextField
						id="outlined-multiline-static"
						label="GraphQl Query"
						multiline
						defaultValue={props.query}
						sx={{minHeight: "500px", height: "100%", width: "100%"}}
						onChange={event => props.setQuery(event.currentTarget.value)}
					/>
				</div>
				<div
					style={{
						width: "40%",
					}}
				>
					<LoadingButton loading={loading} fullWidth={true} onClick={verifyQuery}>Verify Query</LoadingButton>
					<TextField
						id="outlined-multiline-static-result"
						multiline
						value={JSON.stringify(response, null, 4)}
						sx={{minHeight: "500px", height: "100%", width: "100%", border: "0PX"}}
						disabled
					/>
				</div>
			</div>
		</>
	);
};
